import { memo } from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { IndexListItem } from 'components/styles_components/list';
import Boolean from 'components/boolean';
import useMobile from 'hooks/use_mobile';
import DeleteButton from 'components/space_users/button/delete';
import Permission from 'utils/permission';
import Role from 'components/role';

const ListItem = ({ permission, onRemove }) => {
  const isMobile = useMobile();

  const actions = () => {
    return (
      <>
        {permission.role.toLowerCase() !== Permission().OWNER ? (
          <DeleteButton permission={permission} onSuccess={onRemove} />
        ) : (
          '-'
        )}
      </>
    );
  };

  const mobileContent = () => (
    <Grid container className="full-width" spacing={2} alignItems="center">
      <Grid size="grow" sx={{ minWidth: 0 }}>
        <Stack>
          <Typography variant="button" sx={{ wordBreak: 'break-all' }}>
            {permission.user.email}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {permission.user.name} {permission.user.surname}
          </Typography>
          <Typography>
            <Role role={permission.role.toLowerCase()} />
          </Typography>
        </Stack>
      </Grid>
      <Grid size="auto" textAlign="right">
        {actions()}
      </Grid>
    </Grid>
  );

  const desktopContent = () => (
    <Grid container className="full-width" spacing={2}>
      <Grid size={{ xs: 5 }}>{permission.user.email}</Grid>
      <Grid size={{ xs: 3 }} textAlign="center">
        <Role role={permission.role.toLowerCase()} />
      </Grid>
      <Grid size={{ xs: 3 }} textAlign="center">
        <Boolean value={permission.confirmed} />
      </Grid>
      <Grid size={{ xs: 1 }} textAlign="center">
        {actions()}
      </Grid>
    </Grid>
  );

  return <IndexListItem>{isMobile ? mobileContent() : desktopContent()}</IndexListItem>;
};

export default memo(ListItem);
